import { TipoPedidoAPI } from '@/api/tipo-pedido.api';
import { Observable } from 'rxjs';

const api = new TipoPedidoAPI();

const list = (params: any): Observable<any> => {
  return api.list(params);
}

export default {
  list,
}
